import { render, staticRenderFns } from "./Handtekening.vue?vue&type=template&id=ebeedf4c"
import script from "./Handtekening.vue?vue&type=script&lang=js"
export * from "./Handtekening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports